var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 73,
    viewBox: "0 0 50 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74609 17.448C9.74609 21.506 11.3581 25.3977 14.2275 28.2671C17.0969 31.1365 20.9887 32.7486 25.0466 32.7486C29.1046 32.7486 32.9964 31.1365 35.8658 28.2671C38.7352 25.3977 40.3472 21.506 40.3472 17.448C40.3472 13.3901 38.7352 9.4983 35.8658 6.62889C32.9964 3.75948 29.1046 2.14746 25.0466 2.14746C20.9887 2.14746 17.0969 3.75948 14.2275 6.62889C11.3581 9.4983 9.74609 13.3901 9.74609 17.448Z",
    stroke: "#28551A",
    strokeWidth: 3.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09766 70.9996V63.3494C2.09766 59.2914 3.70967 55.3997 6.57908 52.5303C9.44849 49.6608 13.3402 48.0488 17.3982 48.0488H32.6988C36.7567 48.0488 40.6485 49.6608 43.5179 52.5303C46.3873 55.3997 47.9993 59.2914 47.9993 63.3494V70.9996",
    stroke: "#28551A",
    strokeWidth: 3.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPic);
export default __webpack_public_path__ + "static/media/defaultPic.f0007f540b374eceaf43177f9c58ba47.svg";
export { ForwardRef as ReactComponent };